import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(Payment History)',
  collection: {
    endpoint: '/api/admin/team/invoices',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Date)', key: 'date', primary: true, format: 'date' },
      { label: 't(Total)', key: 'total', primary: true, collapsing: true, format: 'currency' },
      { label: 't(Status)', key: 'status', collapsing: true, format: StatusToken  }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'repeat',
      title: 't(No Invoices)',
      text: 't(There have not yet been any invoies for your account)'
    },
    entity: 'invoices',
    onClick: (record) => context.router.push(`/team/invoices/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
